import React from 'react';
import { Container, Typography, Grid, Box } from '@mui/material';
import { motion, useScroll, useTransform } from 'framer-motion';
import './About.css';

// Component imports
import HeroSection from './components/HeroSection';
import WhoWeAreSection from './components/WhoWeAreSection';
import StatsSection from './components/StatsSection';
import ValuesSection from './components/ValuesSection';
import TeamSection from './components/TeamSection';
import Footer from '../../components/Footer';

const About = () => {
  const { scrollYProgress } = useScroll();
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.1]);
  const y = useTransform(scrollYProgress, [0, 1], [0, 100]);

  return (
    <div className="about-page">
      <HeroSection />
      <WhoWeAreSection />
      <StatsSection />
      <ValuesSection />
      {/* <TeamSection /> */}
      <Footer />
    </div>
  );
};

export default About; 